module.exports = __webpack_public_path__ + "img/artist-03.fed9465a.png";